
import InputCheckbox from '@/components/inputs/InputCheckbox/InputCheckbox';
import RenounceButton from '@/components/RenounceButton/RenounceButton';
import { mutations, store } from '@/store/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {
      InputCheckbox,
      RenounceButton,
    },
  })
export default class Consent extends Vue {

    public partId!: number;
    private consentAccepted: boolean = false;

    protected mounted() {
        this.consentAccepted = store.state.consentAccepted;
        this.partId = Number(this.$route.params.partId);
    }

    protected setConsentAccepted(value: boolean) {
        this.consentAccepted = value;
        mutations.setConsentAccepted(value);
    }

    protected onSubmit() {
        this.$router.push({
          name: 'recap',
          params: {
            screening: this.$route.params.screening,
            partId: String(this.partId),
          },
        });
      }
}
